import { render, staticRenderFns } from "./shopFreight.vue?vue&type=template&id=73753a3a&scoped=true"
import script from "./shopFreight.vue?vue&type=script&lang=js"
export * from "./shopFreight.vue?vue&type=script&lang=js"
import style0 from "./shopFreight.vue?vue&type=style&index=0&id=73753a3a&prod&lang=stylus&scoped=true"
import style1 from "./shopFreight.vue?vue&type=style&index=1&id=73753a3a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73753a3a",
  null
  
)

export default component.exports